import React from "react";
import Navbar from "../components/Navbar";
import {
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaPhoneAlt,
  FaUserTie,
  FaGraduationCap,
  FaBolt,
  FaDatabase,
  FaCode,
  FaChartLine,
} from "react-icons/fa";

// 👥 Fotos de los socios (subir estos archivos a src/assets/images/)
import sebastianFoto from "../assets/images/sebastian_lopez.png";
import santiagoFoto from "../assets/images/santiago_hernandez.png";

// ======= SOCIOS FUNDADORES =======
const socios = [
  {
    nombre: "Sebastián López Arias",
    cargo: "CEO",
    foto: sebastianFoto,
    color: "from-[#00b3b3] to-[#00e68a]",
    descripcion:
      "Líder con amplia formación académica y experiencia en el sector energético, combinando conocimientos técnicos profundos con una visión estratégica del negocio.",
    credenciales: [
      { icono: <FaBolt />, texto: "Electrical Engineer" },
      { icono: <FaGraduationCap />, texto: "Msc Electrical Engineering" },
      { icono: <FaGraduationCap />, texto: "Msc Energy Systems" },
      { icono: <FaCode />, texto: "Software Development Spc" },
      { icono: <FaChartLine />, texto: "Energy Markets Spc" },
      { icono: <FaUserTie />, texto: "Operations Management Spc" },
    ],
  },
  {
    nombre: "Santiago Hernández Neira",
    cargo: "CIO · Co-Founder",
    foto: santiagoFoto,
    color: "from-purple-500 to-pink-500",
    descripcion:
      "Ingeniero con sólida formación multidisciplinaria, especializado en ingeniería de datos y desarrollo de software para soluciones inteligentes en el sector energético.",
    credenciales: [
      { icono: <FaDatabase />, texto: "Data Engineer" },
      { icono: <FaCode />, texto: "Senior Software Engineer" },
      { icono: <FaGraduationCap />, texto: "Systems and Telecommunications Engineer" },
      { icono: <FaChartLine />, texto: "Data Analytics Specialist" },
      { icono: <FaCode />, texto: "Software Development" },
      { icono: <FaDatabase />, texto: "Data Analytics Senior" },
    ],
  },
];

export default function SobreNosotrosForm() {
  return (
    <div className="min-h-screen bg-[#1f1b24] text-white font-nexa font-normal flex flex-col">
      {/* ======= NAVBAR ======= */}
      <Navbar />

      {/* ======= CONTENIDO PRINCIPAL ======= */}
      <main className="flex-grow">
       {/* ======= SECCIÓN 1: Sobre QuarkIA ======= */}
        <section className="max-w-5xl mx-auto px-6 md:px-12 py-16 flex flex-col text-center md:text-left">
          <div className="inline-block self-start bg-gradient-to-r from-[#00b3b3] to-[#00ff80] text-[#1f1b24] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl mb-10 shadow-lg">
            Sobre QuarkIA
          </div>

          <div className="text-lg leading-relaxed text-justify text-white/90">
            <p className="mb-6">
              <strong className="text-[#00b3b3]">QuarkIA</strong> es una empresa de
              transformación digital enfocada en el desarrollo de soluciones tecnológicas
              basadas en <strong>analítica de datos</strong> e{" "}
              <strong>inteligencia artificial</strong> para el sector energético.
            </p>
            <p className="mb-6">
              La compañía se especializa en la integración, procesamiento y estructuración
              de información proveniente de fuentes públicas, desarrollando plataformas
              digitales, modelos analíticos y herramientas que facilitan el acceso,
              comprensión y aprovechamiento de datos dentro de las organizaciones.
            </p>
            <p>
              A través de estas soluciones, QuarkIA permite fortalecer la gestión de
              información, mejorar la eficiencia operativa y desarrollar capacidades
              analíticas de forma escalable.
            </p>
          </div>
        </section>

        {/* ======= SECCIÓN 2: Nuestro enfoque ======= */}
        <section className="max-w-5xl mx-auto px-6 md:px-12 py-16 flex flex-col text-center md:text-left">
          <div className="inline-block self-start bg-gradient-to-r from-[#00b3b3] to-[#00ff80] text-[#1f1b24] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl mb-10 shadow-lg">
            Nuestro enfoque
          </div>

          <div className="text-lg leading-relaxed text-justify text-white/90">
            <p className="mb-6">
              El enfoque de <strong className="text-[#00b3b3]">QuarkIA</strong> es
              tecnológico y orientado a la construcción de capacidades.
            </p>
            <p>
              Se diseñan soluciones que permiten a las organizaciones estructurar y
              trabajar su información de manera autónoma, mediante herramientas que
              integran datos, automatizan procesos y facilitan su análisis.
            </p>
          </div>
        </section>

        {/* ======= SECCIÓN 3: El equipo ======= */}
        <section className="max-w-5xl mx-auto px-6 md:px-12 py-16 flex flex-col text-center md:text-left">
          <div className="inline-block self-start bg-gradient-to-r from-[#00b3b3] to-[#00ff80] text-[#1f1b24] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl mb-10 shadow-lg">
            El equipo
          </div>

          <div className="text-lg leading-relaxed text-justify text-white/90">
            <p className="mb-6">
              <strong className="text-[#00b3b3]">QuarkIA</strong> está integrado por un
              equipo de profesionales con formación en ingeniería, analítica de datos y
              sistemas energéticos, enfocado en el desarrollo de soluciones tecnológicas
              y en la estructuración de herramientas para el manejo de información.
            </p>
            <p>
              El equipo cuenta con experiencia en integración de datos, automatización
              de procesos y desarrollo de modelos analíticos, orientados a facilitar el
              aprovechamiento de la información dentro de las organizaciones.
            </p>
          </div>
        </section>

        {/* ======= SECCIÓN 3: Socios fundadores ======= */}
        <section className="max-w-6xl mx-auto px-6 md:px-12 py-16">
          <div className="inline-block self-start bg-gradient-to-r from-[#00b3b3] to-[#00ff80] text-[#1f1b24] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl mb-10 shadow-lg">
            Socios fundadores
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {socios.map((socio, i) => (
              <div
                key={i}
                className="group relative bg-[#2a2533] rounded-3xl overflow-hidden border border-white/5 hover:border-[#00e68a]/40 hover:-translate-y-2 transition-all duration-300 shadow-xl"
              >
                {/* Efecto de fondo al hover */}
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${socio.color} opacity-0 group-hover:opacity-5 transition-opacity pointer-events-none`}
                ></div>

                {/* Foto */}
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={socio.foto}
                    alt={socio.nombre}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2a2533] via-transparent to-transparent"></div>

                  {/* Badge del cargo */}
                  <div
                    className={`absolute top-4 left-4 bg-gradient-to-r ${socio.color} text-[#1f1b24] px-4 py-1.5 rounded-full text-xs font-bold uppercase shadow-lg`}
                  >
                    {socio.cargo}
                  </div>
                </div>

                {/* Información */}
                <div className="relative p-6 md:p-8">
                  {/* Nombre */}
                  <h3 className="text-2xl font-extrabold text-white mb-2 group-hover:text-[#00e68a] transition-colors">
                    {socio.nombre}
                  </h3>

                  {/* Descripción */}
                  <p className="text-gray-300 text-sm leading-relaxed mb-5">
                    {socio.descripcion}
                  </p>

                  {/* Línea separadora */}
                  <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-5"></div>

                  {/* Credenciales */}
                  <div className="space-y-2">
                    {socio.credenciales.map((cred, idx) => (
                      <div
                        key={idx}
                        className="flex items-center gap-3 text-sm text-gray-300"
                      >
                        <span className="text-[#00e68a] flex-shrink-0">
                          {cred.icono}
                        </span>
                        <span>{cred.texto}</span>
                      </div>
                    ))}
                  </div>

                  {/* Línea decorativa inferior */}
                  <div
                    className={`mt-6 h-1 w-0 group-hover:w-full bg-gradient-to-r ${socio.color} rounded-full transition-all duration-500`}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* ======= FOOTER ======= */}
      <footer className="bg-[#16131a] py-8 text-center border-t border-gray-700">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex space-x-6 text-2xl text-[#00b3b3]">
            <a
              href="https://wa.me/573113836855"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaFacebook />
            </a>
          </div>

          {/* 📧 y 📞 */}
          <div className="flex flex-col items-center text-sm md:text-base space-y-2">
            <p className="flex items-center space-x-2">
              <FaEnvelope className="text-[#00b3b3]" />
              <span>info@quarkia.com.co</span>
            </p>
            <p className="flex items-center space-x-2">
              <FaPhoneAlt className="text-[#00b3b3]" />
              <span>+57 311 383 6855</span>
            </p>
          </div>

          <p className="text-gray-400 text-xs mt-4">
            © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
